module.exports = __webpack_public_path__ + "img/logo1 (35).31aa1ea5.jpg";